import React, { Key, MouseEventHandler, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HomeBgItem from "./HomeBgItem";
import Button from "src/components/common/Button";
import ProgressBar from "src/components/common/ProgressBar";
import { useAppSelector } from "src/store/actions/action";
import { AsVo } from "src/vo/asVo";
import moment from "moment";
import { isEmpty } from "lodash";
import StatusTag from "../common/StatusTag";
import SVG from "src/utils/SVG";
import cn from "classnames";
import Box from "../common/Box";
import styled from "styled-components";

interface IBottomProps {
  storeAsList?: Array<any>;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const ShopAsItem = (props: IBottomProps) => {
  const [isAsRequest, setIsAsRequest] = useState(true);

  const [asList, setAsList] = useState<Array<any>>();

  useEffect(() => {
    setAsList(props.storeAsList);
  }, [props]);

  useEffect(() => {
    if (asList) {
      setIsAsRequest(true);
    } else {
      setIsAsRequest(false);
    }
  }, [asList]);

  return (
    <>
      {isAsRequest ? (
        <>
          {!isEmpty(asList) && asList!.length > 0 ? (
            <>
              {asList?.map((info: AsVo, idx: any) => (
                <HomeBgItem key={idx} color="white">
                  <Link to={"/as-detail/" + info.as_idx}>
                    <div>
                      <div className="cate-info">
                        <p className="title">{info.cate_name}</p>
                        <StatusTag value={info.code_name} level={info.code_val} cancel={info.delete_yn === "Y"} />
                      </div>
                      <p className="text">
                        {info.copy_yn === "Y" ? <span className="copy-com">{info.company_name}</span> : ""}
                        {info.contents}
                      </p>
                      <div className="sub-info">
                        <div>
                          <p className="date">{info.insert_date ? moment(info.insert_date).format("YYYY.MM.DD") : "-"}</p>
                          <span className={cn("chat", { new: info.read_yn === "N" })}>
                            {info.read_yn === "N" ? (
                              <SVG name="chatActive" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                            ) : (
                              <SVG name="chat" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                            )}
                            {info.comment_count}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Link>
                </HomeBgItem>
              ))}
              <Box pd="40px 0">
                <Button variant="contained" color="white" br="round" onClick={props.onClick}>
                  A/S 접수
                </Button>
              </Box>
            </>
          ) : (
            <>
              <NoData>
                <p>진행 중인 A/S건이 없습니다.</p>
              </NoData>
              <Box pd="25px 0">
                <Button variant="contained" color="white" br="round" onClick={props.onClick}>
                  A/S 접수
                </Button>
              </Box>
            </>
          )}
        </>
      ) : (
        ""
      )}
    </>
  );
};

const NoData = styled.div`
  padding: 45px 15px;
  border-radius: 4px;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  color: #000;
  text-align: center;
`;

export default ShopAsItem;
